import { Injectable, isDevMode } from '@angular/core';
import { CmsComponentMapping } from '@spartacus/core';
import { CmsComponentsService } from '@spartacus/storefront';

@Injectable({
  providedIn: 'root',
})
export class CustomCmsComponentsService extends CmsComponentsService {
  getMapping(componentType: string): CmsComponentMapping {
    const componentConfig = this.mappings[componentType] ?? this.config.cmsComponents?.[componentType];

    if (isDevMode() && !componentConfig) {
      if (!this.missingComponents.includes(componentType)) {
        this.missingComponents.push(componentType);
        console.warn(
          `No component implementation found for the CMS component type '${componentType}'.\n`,
          `Make sure you implement a component and register it in the mapper.`,
        );
      }
    }

    return componentConfig;
  }
}
